var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ynav',{attrs:{"title":"请选择生产企业"}}),_vm._v(" "),_c('div',{staticClass:"ym_list"},[_c('ul',_vm._l((_vm.producerList),function(item){return _c('li',{key:item,on:{"click":function($event){_vm.pick(item)}}},[_vm._v("\n                 "+_vm._s(item)+"\n             ")])}))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-741385a4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SelectProducer.vue
// module id = null
// module chunks = 